import { atom } from "jotai";
export const backdropAtom = atom<string|undefined>(undefined);
